import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import MonthlySalesChart from "../../components/ecommerce/MonthlySalesChart";
import StatisticsChart from "../../components/ecommerce/StatisticsChart";
import MonthlyTarget from "../../components/ecommerce/MonthlyTarget";
import MeetingData from "../../components/ecommerce/MeetingData";
import CallData from "../../components/ecommerce/CallData";
// import PageMeta from "../../components/common/PageMeta";

export default function Ecommerce() {
  return (
    <>
      {/* <PageMeta
        title="SalesBox"
        description="This is CRM Dashboard Page"
      /> */}
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 space-y-6 xl:col-span-7">
          <EcommerceMetrics />
          {/* <MonthlySalesChart /> */}
        </div>

        <div className="col-span-12 xl:col-span-5">
          <MonthlyTarget />
        </div>

        <div className="col-span-12">
          <MonthlySalesChart />
        </div>
        <div className="col-span-12">
          <StatisticsChart />
        </div>

        <div className="col-span-12 xl:col-span-6">
          <CallData />
        </div>

        <div className="col-span-12 xl:col-span-6">
          <MeetingData />
        </div>
      </div>
    </>
  );
}
